/**
 * Shared FocusTrap configuration used by all modal/dialog components.
 *
 * Centralized here so behavior changes (e.g., disabling clickOutsideDeactivates)
 * only need to happen in one place.
 */
import type { FocusTrapProps } from 'focus-trap-react';

export const FOCUS_TRAP_OPTIONS: FocusTrapProps['focusTrapOptions'] = {
  escapeDeactivates: true,
  clickOutsideDeactivates: true,
  returnFocusOnDeactivate: true,
};
